import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "rsuite/dist/rsuite.min.css";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import App from "./App";
import { ModalsProvider } from "./hooks/modals";
import { ToastContainer } from "react-toastify";
import { aplicarTema, temaEscuroGravado } from "./utils/tema";

// Tema padrão do portal: DARK. Só fica claro se o usuário escolher explicitamente
// (preferência gravada por `aplicarTema`, de qualquer um dos botões de tema).
aplicarTema(temaEscuroGravado(), false);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
    <ModalsProvider></ModalsProvider>
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </BrowserRouter>
);
